const FOOD_DEPLOYS = {
  staging: 'https://food-stg.yassir.io',
  preprod: 'https://food-preprod.yassir.io',
  production: 'https://food.yassir.io',
  development: 'https://food-stg.yassir.io'
}
export { FOOD_DEPLOYS }
